import { render, staticRenderFns } from "./ProductManageAdd.vue?vue&type=template&id=25aa1e50&scoped=true"
import script from "./ProductManageAdd.vue?vue&type=script&lang=js"
export * from "./ProductManageAdd.vue?vue&type=script&lang=js"
import style0 from "./ProductManageAdd.vue?vue&type=style&index=0&id=25aa1e50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aa1e50",
  null
  
)

export default component.exports